import { AfterViewInit, Directive, DoCheck, ElementRef, HostListener, Input, OnInit, Renderer2 } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Directive({
  selector: '[appReactiveContent]',
})
export class ReactiveContentDirective implements OnInit, AfterViewInit, DoCheck {
  @Input() largeContent: string = '';

  @Input() mediumContent: string = '';

  @Input() smallContent: string = '';

  @Input() smallIsIcon: boolean = false;

  @Input() widthSizes: number[] = [100, 50];

  constructor(private el: ElementRef, private renderer: Renderer2, private translate: TranslateService) {}

  ngOnInit() {
    this.setContent();
  }

  ngAfterViewInit() {
    this.setContent();
  }

  ngDoCheck() {
    this.setContent();
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.setContent();
  }

  setContent() {
    if (this.widthSizes.length !== 2) {
      throw new Error('Width sizes must have 2 values');
    }

    this.el.nativeElement.classList.remove('small-icon');

    const width = this.el.nativeElement.offsetWidth;
    const large = this.widthSizes[0];
    const medium = this.widthSizes[1];

    if (width >= large) {
      this.renderer.setProperty(this.el.nativeElement, 'innerHTML', this.translate.instant(this.largeContent));
    } else if (width >= medium) {
      this.renderer.setProperty(this.el.nativeElement, 'innerHTML', this.translate.instant(this.mediumContent));
    } else {
      if (this.smallIsIcon) {
        const iconElement = this.renderer.createElement('mat-icon');
        this.renderer.addClass(iconElement, 'material-icons');
        const text = this.renderer.createText(this.smallContent);
        this.renderer.appendChild(iconElement, text);
        this.renderer.setProperty(this.el.nativeElement, 'innerHTML', '');
        this.renderer.appendChild(this.el.nativeElement, iconElement);
        this.el.nativeElement.classList.add('small-icon');
      } else {
        this.renderer.setProperty(this.el.nativeElement, 'innerHTML', this.translate.instant(this.smallContent));
      }
    }
  }
}
